import FileDownload from 'js-file-download';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

export const PDF_REQUEST = 'LOAD_PDF_REQUEST';
export const PDF_SUCCESS = 'LOAD_PDF_SUCCESS';
export const PDF_FAIL = 'LOAD_PDF_FAIL';

export const loadPdfRequest = () => ({ type: PDF_REQUEST });
export const loadPdfFail = (error) => ({ type: PDF_FAIL, error });
export const loadPdfSuccess = () => ({ type: PDF_SUCCESS });

export const loadPdfExport = (request) => (dispatch) => {
  dispatch(loadPdfRequest());
  return communicate({
    url: request.url, method: 'get', getParams: request.query, responseType: 'blob'
  }).then((response) => {
    dispatch(loadPdfSuccess());
    const fileName = response.headers['x-suggested-filename'] || 'Raport.pdf';
    FileDownload(response.data, fileName);
  }).catch((error) => {
    toastrError(error);
    dispatch(loadPdfFail(error));
  });
};
